import { HttpError, NetworkError } from '@/lib/exception';

export const errorHandler = ({
  error,
  alertMessage,
}: {
  error: Error;
  alertMessage?: string;
}): never => {
  const wrappedAlert = (message: string) => alert(alertMessage || message);

  if (error instanceof HttpError) {
    switch (error.status) {
      // 400 の場合はバリデーションエラーなので基本的にフロント側でチェックする
      // フロントのバリデーションをすり抜けた場合はデフォルトのエラーメッセージを表示する
      case 401:
        if (location.pathname !== '/login') {
          location.href = '/login';
        }
        throw error;

      case 403:
        wrappedAlert('エラーが発生しました。認証情報をお確かめください。');
        throw error;

      case 404:
        location.href = '/404';
        wrappedAlert('ページが見つかりませんでした。');
        throw error;

      case 500:
        location.href = '/500';
        wrappedAlert('サーバーエラーが発生しました。');
        throw error;

      default:
        wrappedAlert('エラーが発生しました。');
        throw error;
    }
  }

  if (error instanceof NetworkError) {
    wrappedAlert(
      'ネットワークエラーが発生しました。通信状況をお確かめください。'
    );
    throw error;
  }

  wrappedAlert('エラーが発生しました。');
  throw error;
};
